import { Component, Prop, Vue } from 'vue-property-decorator';
import MixinChart from '@/plugins/podolib/services/helper/mixins/chart/index';
import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';
export enum Type {
  Walking = 'podosmart',
  Running = 'podorun',
}

@Component
export default class MixinChartStandard extends MixinChart {
  @Prop({ required: false }) protected acquisitionInfos!: any;
  @Prop({ required: true }) protected values!: TAcquisition['computed_data'];
  @Prop({ default: null }) protected compareValues!: TAcquisition;

  get left() {
    return this.values.left.aggregates;
  }
  get right() {
    return this.values.right.aggregates;
  }
}

@Component
export class MixinChartGroupStandard extends Vue {
  @Prop({ required: true }) protected acquisition!: TAcquisition;
  @Prop({ default: false }) protected comparison!: boolean;
}
